import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { reactI18nextModule } from "react-i18next";
// constant
import { FALLBACK_LNG } from "../constants";
// default translations
import bookings from "./en-GB/bookings.json";
import common from "./en-GB/common.json";
import errors from "./en-GB/errors.json";
import exams from "./en-GB/exams.json";
import generals from "./en-GB/generals.json";
import login from "./en-GB/login.json";
import passwordChange from "./en-GB/passwordChange.json";
import profileChange from "./en-GB/profileChange.json";
import settings from "./en-GB/settings.json";
import smartNotification from "./en-GB/smartNotification.json";
import userMenu from "./en-GB/userMenu.json";
import usersList from "./en-GB/usersList.json";
import vouchers from "./en-GB/vouchers.json";
import manualAssignment from "./en-GB/manualAssignment.json";
import payment from "./en-GB/payment.json";
import paymentHistory from "./en-GB/paymentHistory.json";

const resources = {
  [FALLBACK_LNG]: {
    translation: {
      ...bookings,
      ...common,
      ...errors,
      ...exams,
      ...generals,
      ...login,
      ...passwordChange,
      ...profileChange,
      ...settings,
      ...smartNotification,
      ...userMenu,
      ...usersList,
      ...vouchers,
      ...manualAssignment,
      ...payment,
      ...paymentHistory
    }
  }
};

i18n
  .use(detector)
  .use(reactI18nextModule)
  .init({
    detection: {
      order: [`localStorage`]
    },
    resources,
    fallbackLng: FALLBACK_LNG,
    keySeparator: true,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
